import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "components/Modal";
import TripMap from "components/TripMap";

// Components
import TripHeader from "./components/TripHeader";
import TripDates from "./components/TripDates";
import TripOperatorInfo from "./components/TripOperatorInfo";
import StagesList from "./components/StagesList";
import AnswersList from "./components/AnswersList";

// Hooks & Utils
import { useTripData } from "./hooks/useTripData";
import { useAnswers } from "./hooks/useAnswers";
import {
  getLastPosition,
  getLastDate,
  getStartDate,
  getPaths,
  getActiveClassTab,
} from "./utils/tripHelpers";

const ModalDetailTrip = ({ openModal, data, closeModal }) => {
  const [tabActive, setTabActive] = React.useState(0);
  const [stage, setStage] = React.useState({});
  const [t] = useTranslation("monitoring");

  const { REACT_APP_BUCKET_BASE_URL, PUBLIC_URL } = process.env;

  // Custom hooks
  const { carrier, status } = useTripData(data);
  const { answers, click, handleQuestions, handleOpenAll, resetAnswers } = useAnswers();

  return openModal ? (
    <Modal
      openModal={openModal}
      closeModal={() => {
        closeModal();
        resetAnswers();
        setStage({});
      }}
      titleModal="Detalle Viaje"
      hiddenButtonDefault
      size={"xlg"}
    >
      <div className="pb-4">
        <TripHeader
          data={data}
          status={status}
          getStartDate={() => getStartDate(data)}
          t={t}
        />

        <TripDates data={data} t={t} />

        <TripOperatorInfo
          data={data}
          carrier={carrier}
          getLastDate={() => getLastDate(data)}
          t={t}
        />
      </div>

      <div className="border-b border-gray-200 dark:border-gray-700">
        <ul className="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
          <li className="mr-2">
            <a
              href="#black"
              className={getActiveClassTab(0, tabActive)}
              onClick={(event) => {
                event.preventDefault();
                setTabActive(0);
              }}
            >
              <img
                alt="#"
                src={`${PUBLIC_URL}/icons/encuesta.png`}
                className="objet-cover h-[20px]"
              />
              &nbsp; {t("modalDetailTrip.sondeos")}
            </a>
          </li>
          <li className="mr-2">
            <a
              href="#black"
              className={getActiveClassTab(1, tabActive)}
              aria-current="page"
              onClick={(event) => {
                event.preventDefault();
                setTabActive(1);
              }}
            >
              <img
                alt="#"
                src={`${PUBLIC_URL}/icons/delivery.png`}
                className="objet-cover h-[20px]"
              />
              &nbsp; {t("modalDetailTrip.map")}
            </a>
          </li>
        </ul>
      </div>

      {tabActive === 0 ? (
        <div className="grid grid-cols-40/60">
          <StagesList
            stage={stage}
            data={data}
            handleQuestions={handleQuestions}
          />

          <AnswersList
            answers={answers}
            click={click}
            handleOpenAll={handleOpenAll}
            t={t}
            REACT_APP_BUCKET_BASE_URL={REACT_APP_BUCKET_BASE_URL}
          />
        </div>
      ) : null}

      {tabActive === 1 ? (
        <div className="h-[360px] w-full bg-red-400">
          <TripMap lastLocation={getLastPosition(data)} paths={getPaths(data)} />
        </div>
      ) : null}
    </Modal>
  ) : null;
};

export default ModalDetailTrip;
